export const environment = {
  production: true,
  apiUrl: "https://preview.mail-archiver.itkaufmann.cloud/api",
  apiFileUrl: "https://preview.mail-archiver.itkaufmann.cloud/",
  passwordMinLength: 8,
  displayDateFormat: "dd.MM.yyyy",
  displayDateTimeFormat: "dd.MM.yyyy HH:mm",
  serverDateFormat: "yyyy-MM-dd",
};
